import { TABLE_ROWS_PER_PAGE } from 'lib/tableLib'
import { useCallback, useState } from 'react'

function useTablePagination({ rowsPerPage, page } = {}) {
  const [newRowsPerPage, setNewRowsPerPage] = useState(
    rowsPerPage || TABLE_ROWS_PER_PAGE
  )
  const [newPage, setNewPage] = useState(page || 0)

  const handleChangePage = useCallback((event, newPage) => {
    setNewPage(newPage)
  }, [])

  const handleChangeRowsPerPage = useCallback((event) => {
    setNewRowsPerPage(parseInt(event.target.value, 10))
    setNewPage(0)
  }, [])
  return {
    page: newPage,
    rowsPerPage: newRowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  }
}

export default useTablePagination
